import keycloakMgr from "../Keycloak";

const RoleUtils = {
    getUserRoles() {
        return keycloakMgr.get()?.tokenParsed?.resource_access?.["map-cockpit"]?.roles || [];
    },

    hasAnyRole(roles) {
        if (!roles || roles.length === 0) {
            return true;
        }
        const userRoles = this.getUserRoles();
        return roles.some(role => userRoles.includes(role));
    }
};

export default RoleUtils;
